import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioProjectStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('studio-project', reducer),
        EffectsModule.forFeature([StudioProjectStoreEffects]),
    ],
    providers: [],
})
export class StudioProjectStoreModule { }
